import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { maskTelefone } from '@/lib/formatters';

import type { ClienteFormData } from './clienteFormUtils';

interface StepContatoProps {
  form: ClienteFormData;
  errors: Record<string, string>;
  set: (field: keyof ClienteFormData, value: string) => void;
}

export function StepContato({ form, errors, set }: StepContatoProps) {
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <div className="space-y-1.5 sm:col-span-2">
        <Label htmlFor="email">E-mail</Label>
        <Input
          id="email"
          type="email"
          autoFocus
          value={form.email}
          onChange={(e) => set('email', e.target.value)}
          placeholder="email@exemplo.com"
          className={errors.email ? 'border-destructive' : ''}
          aria-invalid={!!errors.email}
        />
        {errors.email && <p className="text-xs text-destructive">{errors.email}</p>}
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="telefone">Telefone</Label>
        <Input
          id="telefone"
          value={form.telefone}
          onChange={(e) => set('telefone', maskTelefone(e.target.value))}
          placeholder="(00) 00000-0000"
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="telefone2">Telefone 2</Label>
        <Input
          id="telefone2"
          value={form.telefone2}
          onChange={(e) => set('telefone2', maskTelefone(e.target.value))}
          placeholder="(00) 00000-0000"
        />
      </div>
    </div>
  );
}
